<template>
  <div class="content-wrapper">
    <!-- Content Header (Page header) -->
    <section class="content-header">
      <h1>
        Cost & Acquisition
        <small>Log Weekly Report</small>
      </h1>
      <ol class="breadcrumb">
        <li><a href="#"><i class="fa fa-dashboard"></i> Cost & Acquisition</a></li>
        <li class="active">Log Weekly Report</li>
      </ol>
    </section>

    <!-- Main content -->
    <section class="content">
      <div class="row">
        <div class="col-xs-12">
          <div class="box">
            <div class="box-body">
              <div class="col-xs-12 col-sm-10 col-sm-offset-1">
                <form class="col-xs-12 col-sm-6" v-if="!loading" role="form" v-on:submit.prevent="logReport">
                  <div class="form-group">
                    <label class="compuslory" for="channel">Channel Name</label>
                    <select ref="channel" class="form-control" id="channel" v-model="reportForm.channel">
                      <option disabled value="">--Select channel--</option>
                      <option v-for="(eachChannel, index) in channels" :value="eachChannel._id" :key="index">{{eachChannel.name}}</option>
                    </select>
                  </div>

                  <div class="form-group">
                    <label class="compuslory">Cost</label>
                    <input type="text" v-model.number="reportForm.spend" class="form-control" />
                  </div>

                  <div class="form-group">
                    <label class="compuslory">Impressions</label>
                    <input type="number" v-model.number="reportForm.impressions" class="form-control" />
                  </div>

                  <div class="form-group">
                    <label class="compuslory">Reach</label>
                    <input type="number" v-model.number="reportForm.reach" class="form-control" />
                  </div>

                  <div class="form-group">
                    <label class="compuslory">Action</label>
                    <input type="number" v-model.number="reportForm.action" class="form-control" />
                  </div>

                  <div class="form-group">
                    <label class="compuslory">Date/Week (YYYY-MM-DD)</label>
                    <input type="text" v-model="reportForm.week" class="form-control" />
                  </div>

                  <div class="form-group">
                    <label>Description</label>
                    <textarea type="text" v-model="reportForm.description" class="form-control"></textarea>
                  </div>

                  <div v-if="submitting" class="form-loader"><img src="/static/img/loader.gif" /></div>
                  <div class="form-group">
                    <p v-if="!submitting" :class="message.style">{{message.text}}</p>
                  </div>
                  <div class="box-footer">
                    <button v-if="!submitting" type="submit" class="btn btn-primary">Submit</button>
                  </div>
                </form>

                <div class="loader" v-if="loading">
                  <img src="/static/img/loader.gif" />
                </div>

                <div class="col-xs-12" v-if="reports.length && !loading">
                  <br/><br/><h3>All Logged Reports</h3>
                  <table class="table table-bordered table-hover">
                    <thead>
                      <tr>
                        <th>S/N</th>
                        <th>Channel</th>
                        <th>Cost</th>
                        <th>Impressions</th>
                        <th>Reach</th>
                        <th>Action</th>
                        <th>Description</th>
                        <th>Date/Week</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(report, index) in reports" :key="index">
                        <td>{{index+1}}</td>
                        <td>{{report.channel.name}}</td>
                        <td>{{report.spend}}</td>
                        <td>{{report.impressions}}</td>
                        <td>{{report.reach}}</td>
                        <td>{{report.action}}</td>
                        <td>{{report.description}}</td>
                        <td>{{report.week}}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <div class="col-xs-12 error" v-if="!loading && !reports.length">Reports could not be retrieved</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- /.row -->
    </section>
    <!-- /.content -->
  </div>
</template>

<script>
import api from '../../../utils/api'
import { showMessage } from '../../../utils'

export default {
  data () {
    return {
      loading: true,
      reports: [],
      submitting: false,
      channels: [],
      reportForm: {
        channel: '',
        spend: '',
        impressions: '',
        reach: '',
        week: '',
        description: '',
        action: ''
      },
      message: {
        style: '',
        text: ''
      }
    }
  },
  methods: {
    logReport () {
      const { channel, spend, impressions, reach, action, week } = this.reportForm
      const index = this.$refs.channel.selectedIndex
      if (!channel || !spend || !impressions || !reach || !week || !action) {
        return showMessage(this, 'error', 'You missed a compulsory field')
      }
      if (isNaN(spend)) {
        return showMessage(this, 'error', 'Cost must be a number')
      }
      api.buildRequest('report', 'post', this.reportForm)
        .then((response) => {
          const status = response.status === 201 ? 'success' : 'error'
          showMessage(this, status, response.data.payload.msg)
          if (status === 'success') {
            this.resetForm()
            const { details } = response.data.payload
            details.channel = this.channels[index - 1]
            this.reports.push(details)
          }
        }).catch(() => {
          showMessage(this, 'error', 'An server error occurred')
        })
    },

    resetForm () {
      for (let key in this.reportForm) {
        this.reportForm[key] = ''
      }
    },

    getAllReports () {
      return new Promise((resolve, reject) => {
        api.buildRequest('report', 'get')
          .then(response => {
            const { status, data } = response
            return status === 200 ? resolve(data.payload) : reject(false)
          }).catch((err) => {
            reject(err)
          })
      })
    },

    getAllChannels () {
      // get all created channels
      return new Promise((resolve, reject) => {
        api.buildRequest('channel', 'get')
          .then(response => {
            const { status, data } = response
            return status === 200 ? resolve(data.payload) : reject(false)
          }).catch((err) => {
            reject(err)
          })
      })
    },

    async getData () {
      try {
        this.channels = await this.getAllChannels()
        this.reports = await this.getAllReports()
      } catch (e) {
        // console.log(error)
      }
      this.loading = false
    }
  },
  mounted () {
    this.getData()
  }
}
</script>

<style>
  label.compuslory:after {
    content: "*";
    color: red;
  }
</style>




// WEBPACK FOOTER //
// Report.vue?8cb9e6aa